import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/components/site/seo-copy";
import EmployersView from "@/components/cl/views/EmployersView";

export const Route = createFileRoute("/for-employers")({
  head: () => pageHead("/for-employers"),
  component: EmployersView,
});
